import React, { useState } from "react";
import "./OffersPage.css";
import { Box } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { IOffer } from "../../../../Interface/scheduler/form";
import { OFFER_COMPONENT_CONSTANTS } from "../../../../constants/constant";
import { useFormContext } from "../../../../common/contexts/FormContext";

interface IOffersPageProps {
  offerDetails: IOffer;
  width?: string;
  offerRemoved?: boolean;
}

export const OffersPage = ({
  offerDetails,
  width,
  offerRemoved,
}: IOffersPageProps) => {
  const [displayOffer, setDisplayOffer] = useState(true);
  const { formValues } = useFormContext();
  if (offerRemoved) {
    return (
      <Box
        className="offers-wrapper"
        sx={{ backgroundColor: "primary.light", color: "primary.dark" }}
        style={{ width: width ?? "100%" }}
      >
        <div className="offers-details-wrap">
          <div className="offer-banner-main">
            <div className="offer-heading">
              {formValues?.isServiceModifier
                ? OFFER_COMPONENT_CONSTANTS.OFFER_DROPPED_SERVICE_TYPE_TEXT
                : OFFER_COMPONENT_CONSTANTS.OFFER_REMOVED_TEXT}
            </div>
          </div>
        </div>
      </Box>
    );
  }

  return (
    <Box
      className="offers-wrapper"
      sx={{ backgroundColor: "primary.light", color: "primary.dark" }}
      style={{ width: width ?? "100%" }}
    >
      <div className="offers-details-wrap">
        <div
          className={`offer-banner-main ${!displayOffer ? "hide-offer" : ""}`}
        >
          <div className="offer-heading">{offerDetails?.title}</div>
          <div className="offer-text">
            {offerDetails?.description} {offerDetails?.couponexpirydate}
          </div>
        </div>
        <div className="applied-text">
          <CheckCircleOutlineIcon
            style={{ marginRight: "4px", color: "#43b02a" }}
          />
          <span>{OFFER_COMPONENT_CONSTANTS.OFFER_ATTACHED_TEXT}</span>
          <button
            className="offer-arrow"
            onClick={() => setDisplayOffer(!displayOffer)}
            aria-label={
              displayOffer ? "Hide offer details" : "Show offer details"
            }
          >
            {displayOffer ? (
              <KeyboardArrowUpIcon color="primary" />
            ) : (
              <KeyboardArrowDownIcon color="primary" />
            )}
          </button>
        </div>
      </div>
    </Box>
  );
};
